import React, { useState } from 'react';

export type Props = {
    link?: string;
    onClick?: () => void;
    small?: boolean;
    className?: string;
    disabled?: boolean;
    children?: React.ReactNode;
};

export default function Button({ link, onClick, small, className, disabled, children }: Props): JSX.Element {
    const [dragging, setDragging] = useState(false);

    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.preventDefault();
        if (disabled) return;
        if (!dragging) {
            onClick && onClick();
        }
        setDragging(false);
    };

    const handleTouch = (e: React.TouchEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (disabled) return;
        if (!dragging) {
            onClick && onClick();
        }
        setDragging(false);
    };

    const wrapperClass = [small ? className : `${className} ${className}__small`, disabled ? 'is-disabled' : '']
        .filter(Boolean)
        .join(' ');

    return (
        <div className={wrapperClass} aria-disabled={disabled || undefined}>
            {link && (
                <a href={link} target="_blank" rel="noopener noreferrer">
                    {children}
                </a>
            )}
            {!link && !onClick && <span className="date">{children}</span>}
            {!link && onClick && (
                <span
                    className="action"
                    onTouchStart={() => {
                        setDragging(false);
                    }}
                    onTouchMove={() => {
                        setDragging(true);
                    }}
                    onTouchEnd={handleTouch}
                    onClick={handleClick}
                >
                    {children}
                </span>
            )}
        </div>
    );
}
